import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'
import { ToastContext } from '../Context/ToastContext'
import ToastContainer from '../ToastContainer'

const MAX_TOASTS = 5

export default function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])

  const removeToast = useCallback((id) => {
    setToasts((current) => current.filter((toast) => toast.id !== id))
  }, [])

  const addToast = useCallback(
    (toast) => {
      setToasts((current) => [...current, toast].slice(-MAX_TOASTS))
    },
    [removeToast]
  )

  return (
    <ToastContext.Provider
      value={{
        addToast,
        removeToast,
      }}
    >
      {children}

      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  )
}

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
